import { PH_NO_CAPTURE } from "@/constants/posthog";
import { Icon, InputAdornment, TextField } from "@mui/material";
import { FC } from "react";
import { SearchSvg } from "@/components/Icon/Icon";

interface SearchFieldProps {
  value: string;
  onChange: (str: string) => void;
  placeholder: string;
  id?: string;
}

export const SearchField: FC<SearchFieldProps> = ({ value, onChange, placeholder, id }) => {
  return (
    <TextField
      className={PH_NO_CAPTURE}
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      placeholder={placeholder}
      size="small"
      slotProps={{
        input: {
          style: { borderRadius: "40px", height: "40px", margin: "6px 0px" },
          startAdornment: (
            <InputAdornment position="start">
              <Icon>
                <SearchSvg color="inherit" />
              </Icon>
            </InputAdornment>
          )
        }
      }}
    />
  );
};
